import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import { motion } from "framer-motion";
import { navItems } from "../data/NavItem";

const TopNavigation: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation(); // ✅ FIX HERE

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
    role="navigation"
      className={`w-full bg-white/80 dark:bg-slateGray/80 border-b border-gray-200 dark:border-gray-700 transition-all duration-300
      ${isSticky ? "fixed top-24 z-30 backdrop-blur shadow-md" : "relative"}
    `}
    >
      <ul className="flex items-center justify-center">
        {navItems.map((item) => {
          // ✅ FIX ACTIVE CHECK
          const isActive = location.pathname === item.href;

          return (
            <li key={item.id} className="relative group">
              <Link
                to={item.href}
                className={`relative flex items-center w-14 h-14 justify-center rounded-lg transition
                  ${
                    isActive
                      ? "text-primary"
                      : "text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800"
                  }
                `}
              >
                <Icon icon={item.icon} className="text-2xl" />

                {/* Animated Underline */}
                {isActive && (
                  <motion.span
                    layoutId="nav-underline"
                    className="absolute bottom-0 left-2 right-2 h-1 rounded-full bg-primary"
                    transition={{
                      type: "spring",
                      stiffness: 500,
                      damping: 30,
                    }}
                  />
                )}
              </Link>

              {/* Tooltip */}
              <div className="pointer-events-none absolute -top-1 left-1/2 -translate-x-1/2
                whitespace-nowrap rounded-md bg-gray-800 px-2 py-1 text-xs text-white
                opacity-0 group-hover:opacity-100 transition"
              >
                {item.label}
              </div>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default TopNavigation;